import { getTransferRequests } from 'client/stock-transfers/stock-transfers.client'
import type { TransferPageData } from 'types/commons/model'

export const assemblyLoader = async (): Promise<TransferPageData> => {
  return await getTransferRequests([
    'readyForLoading',
    'pending',
    'readyToWrap',
    'inProgress'
  ])
}
